<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Candal&family=Kalam:wght@300;400;700&display=swap"
  rel="stylesheet">

<div style="display:flex; flex-direction: column; justify-content: space-between;">


  <br>
  <button mat-raised-button (click)="callWebhookCielo()">
    callWebhookCielo
  </button>

  <br>
  <br>
  <button mat-raised-button (click)="gerarRecibo()">
    gerarRecibo
  </button>

  <br>
  <br>
  <button mat-raised-button (click)="dismemberOrder()">
    dismemberOrder
  </button>




  <br>
  <br>
  <button mat-raised-button (click)="getCountries()">
    getCountries
  </button>

  <br>
  <br>
  <button mat-raised-button (click)="loadMembers()">
    loadMembers
  </button>
  <!--
  <br>
  <mat-form-field appearance="outline">
    <input matInput placeholder="Teste">
  </mat-form-field>
  <br>
  <br>
  <mat-form-field class="name-width" appearance="fill">
     <mat-label>Nome *</mat-label>
    <input matInput type="text" autocomplete="off">
    <mat-error>
      O Nome é obrigatório
    </mat-error>
  </mat-form-field>

  <br>
  <br>

  <button mat-raised-button (click)="getAuth()">
    getAuth
  </button>
-->

  <!--  <br>

    <button mat-raised-button (click)="getPublishedCollection()">
    getPublishedCollection
  </button>

  <button mat-raised-button (click)="analizeLogs()">
    analizeLogs
  </button>
  <br>




  <button mat-raised-button (click)="simulateWebhookAction()">
    simulateWebhookAction
  </button>
  <br>

  <button mat-raised-button (click)="crypto()">
    Crypto
  </button>
  <br>
  <button mat-raised-button (click)="decrypto()">
    Decrypto
  </button>
  <br>


  <br>
  <br>

  <button mat-raised-button (click)="getClientByNameDev()">
    Clients By Name DEV
  </button>

  <br>

  <button mat-raised-button (click)="getClientByName()">
    Clients By Name
  </button>

  <br>

  <button mat-raised-button (click)="getClientByCpf()">
    Clients By CPF
  </button>

  <br>

  <button mat-raised-button (click)="listClients()">
    List Clients
  </button>

  <br>

  <button mat-raised-button (click)="createClientDev('')">
    Create Client DEV
  </button>

  <br>

  <button mat-raised-button (click)="createClient('')">
    Create Client
  </button>

  <br>

  <button mat-raised-button (click)="checkClient()">
    Check Client
  </button>

  <br>

  <button mat-raised-button (click)="creditCard()">
    Credit Card
  </button>

  <br>

  <button mat-raised-button (click)="createClient('boleto')">
    Boleto
  </button>

  <br>

  <button mat-raised-button (click)="boleto('pix')">
    PIX
  </button>

  <br>

  <button mat-raised-button (click)="listMembers()">
    Members
  </button>

  <button mat-raised-button (click)="testPaymentConfirmed()">
    Testar PAYMENT_CONFIRMED
  </button>

  <button style='color:green;' mat-raised-button (click)="callSalesProcessV1()">
    callSalesProcessV1
  </button>
  

    <button style='color:green;' mat-raised-button (click)="testPushing()">
    testPushing
  </button>

  <button style='color:green;' mat-raised-button (click)="testPushingMulticast()">
    testPushingMulticast
  </button>

  <button style='color:green;' mat-raised-button (click)="UpdateCRMs()">
    UpdateCRMs
  </button>


-->

  <!--


  <button style='color:blue;' mat-raised-button (click)="loadAllMembers()">
    Load All Members
  </button>
  
  <button style='color:green;' mat-raised-button (click)="checkData()">
    checkData
  </button>
  
  <button style='color:green;' mat-raised-button (click)="loadMembersBackgrounds()">
    loadMembersBackgrounds
  </button>

  <button style='color:green;' mat-raised-button (click)="insertMembersBackgrounds()">
    insertMembersBackgrounds
  </button>
-->

  <!--  

  <input id='selectedFile' style="display: none;" #file type="file" (change)="readCSVFile($event)" />
  <button style='color:blue;' mat-raised-button onclick="document.getElementById('selectedFile').click();">
    3 - LOAD SPREADSHEET
  </button>

  <button style='color:blue;' mat-raised-button (click)="getMemberAllAnnuities()">
    getMemberAllAnnuities
    </button>

  <button style='color:blue;' mat-raised-button (click)="insertCategories()">
  Insert Categories
  </button>
  


  <mat-form-field style="width: 200px; margin: auto;">
    <input matInput type="text" [(ngModel)]='memberId'
    placeholder="ID" autocomplete="off">
</mat-form-field>

  <button style='color:blue;' mat-raised-button (click)="getMember()">
    Get Member
  </button>



  <button style='color:blue;' mat-raised-button (click)="loadMembers()">
    1 - LOAD MEMBERS
  </button>

  <button style='color:blue;' mat-raised-button (click)="loadCategoriesDB()">
    2 - LOAD CATEGORIES DB
  </button>

  <input id='selectedFile' style="display: none;" #file type="file" (change)="readCSVFile($event)" />
  <button style='color:blue;' mat-raised-button onclick="document.getElementById('selectedFile').click();">
    3 - LOAD CATEGORIES CSV
  </button>



  <button style='color:green;' mat-raised-button (click)="findDuplicatedData()">
    5 - FIND DUPLICATED
  </button>

  <button style='color:green;' mat-raised-button (click)="mergeCategories()">
    5 - MERGE
  </button>

  <button style='color:green;' mat-raised-button (click)="uploadCategories()">
    5 - UPLOAD CATEGORIED
  </button>

  <hr>

  <button style='color:green;' mat-raised-button (click)="loadAnnotationFlagTrue()">
    Annotation Flag = true
  </button>

  <button style='color:blue;' mat-raised-button (click)="annotationToUpdate()">
    Annotation to Update
  </button>
   -->

  <!--
  <button style='color:blue;' mat-raised-button (click)="loadAnotationsDBFlagTrue()">
    2.1 - LOAD ANNOTATIONS DB FLAG TRUE
  </button>
  
  <button style='color:blue;' mat-raised-button (click)="annotationToUpdate()">
    2.2 - LOAD ANNOTATIONS TO UPDATE
  </button>

  <input id='selectedFile' style="display: none;" #file type="file" (change)="readCSVFile($event)" />
  <button style='color:blue;' mat-raised-button onclick="document.getElementById('selectedFile').click();">
    3 - LOAD ANNOTATION CSV
  </button>

  <button style='color:green;' mat-raised-button (click)="processSpreadsheet()">
    4 - PROCESS SPREADSHEET
  </button>

  
  <button style='color:green;' mat-raised-button (click)="findDuplicatedData()">
    5 - FIND DUPLICATED
  </button>


  <button style='color:green;' mat-raised-button (click)="annotationFinalProcess()">
    6 - ANNOTATION FINAL LIST
  </button>

  <button style='color:green;' mat-raised-button (click)="annotationInsert()">
    6 - ANNOTATION INSERT
  </button>
 
-->

  <!--
  <button style='color:blue;' mat-raised-button (click)="loadOldSubCategories()">
    2 - LOAD HISTORY
  </button>






  <button style='color:green;' mat-raised-button (click)="findDuplicatedData()">
    5 - PROCESS DATA
  </button>

  <button style='color:green;' mat-raised-button (click)="loadAllCategories()">
    6 - LOAD CATEGORIES
  </button>

  <button style='color:green;' mat-raised-button (click)="processNewCategories()">
    7 - LOAD CATEGORIES
  </button>

  <button style='color:green;' mat-raised-button (click)="getCategoryInTheList()">
    8 - GET CATEGORIES
  </button>

  <button style='color:green;' mat-raised-button (click)="categoriesFinalProcess()">
    9 - MAKE FINAL LIST
  </button>



  <button style='color:green;' mat-raised-button (click)="insertAnnotations()">
    11 - INSERT ANNOTATIONS
  </button>

  -->



</div>